import view from "../views/index";
import viewHelper from "../helpers/view"
import Analitycs from "../helpers/analytics"

export const initMostrarError = () => {
    window.mostrar_error = (params) => {
        view('MOSTRAR_ERROR', params, callback);
        viewHelper.hidePreloader();
    }
}

const callback = (params) => {
    let { message } = params;
    let { error } = params;
    if (!message) {
        message = "Ha ocurrido un error inesperado"
    }
    Analitycs.error(error);
}





// WEBPACK FOOTER //
// ./Statics/scripts/paywall/controllers/error.js